<template>
  <div>
    <div class="banner">
      <div class="headerReplacementFinancialInfo"></div>
      <div class="banner-text">
        <b>{{ $t('financialInfo.pageTitle') }}</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">{{ $t('financialInfo.breadcrumbHome') }}</router-link></span>
          <span class="separator"></span>
          <span>{{ $t('financialInfo.breadcrumbFinancial') }}</span>
          <span class="separator"></span>
          <span><b>{{ $t('financialInfo.pageTitle') }}</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <FinancialInfoTabMenu />
      </div>

      <div class="row justify-content-center">
        <div ref="chartContainer" class="mt-5" style="width: 90%; height: 400px;"></div>
      </div>

      <div class="mt-5 mb-3">{{ $t('financialInfo.unit') }}</div>

      <div class="table-responsive">
        <table class="table mb-5">
          <!-- Year Header -->
          <thead>
            <tr class="table-dark text-end">
              <th scope="col"></th>
              <th scope="col">{{ $t('financialInfo.tableHeaders.year[0]') }}</th>
              <th scope="col">{{ $t('financialInfo.tableHeaders.year[1]') }}</th>
              <th scope="col">{{ $t('financialInfo.tableHeaders.year[2]') }}</th>
            </tr>
          </thead>

          <!-- Section: Key Financial Data -->
          <thead>
            <tr class="table-secondary">
              <th colspan="4"><b>{{ $t('financialInfo.tableHeaders.section1') }}</b></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.totalAssets') }}</th>
              <td>{{ financialData[0]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[0]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[0]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.totalLiabilities') }}</th>
              <td>{{ financialData[1]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[1]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[1]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.equity') }}</th>
              <td>{{ financialData[2]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[2]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[2]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.salesRevenue') }}</th>
              <td>{{ financialData[3]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[3]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[3]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.totalRevenue') }}</th>
              <td>{{ financialData[4]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[4]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[4]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.costOfSales') }}</th>
              <td>{{ financialData[5]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[5]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[5]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.totalExpenses') }}</th>
              <td>{{ financialData[6]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[6]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[6]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.tableHeaders.netProfit') }}</th>
              <td>{{ financialData[7]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialData[7]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialData[7]?.year_2567 || 'N/A' }}</td>
            </tr>

            <!-- Section: Financial Ratios -->
            <tr class="table-secondary">
              <th colspan="4"><b>{{ $t('financialInfo.section2Title') }}</b></th>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.roe') }}</th>
              <td>{{ financialRatios[0]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[0]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[0]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.roa') }}</th>
              <td>{{ financialRatios[1]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[1]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[1]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.grossProfitMargin') }}</th>
              <td>{{ financialRatios[2]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[2]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[2]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.netProfitMargin') }}</th>
              <td>{{ financialRatios[3]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[3]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[3]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.debtToEquity') }}</th>
              <td>{{ financialRatios[4]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[4]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[4]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.ibdToEquity') }}</th>
              <td>{{ financialRatios[5]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[5]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[5]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.ratios.assetTurnover') }}</th>
              <td>{{ financialRatios[6]?.year_2565 || 'N/A' }}</td>
              <td>{{ financialRatios[6]?.year_2566 || 'N/A' }}</td>
              <td>{{ financialRatios[6]?.year_2567 || 'N/A' }}</td>
            </tr>

            <!-- Section: Statistical Information -->
            <tr class="table-secondary">
              <th colspan="4"><b>{{ $t('financialInfo.section3Title') }}</b></th>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.registeredShares') }}</th>
              <td>{{ statisticalInformation[0]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[0]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[0]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.parValue') }}</th>
              <td>{{ statisticalInformation[1]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[1]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[1]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.marketCap') }}</th>
              <td>{{ statisticalInformation[2]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[2]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[2]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.bvps') }}</th>
              <td>{{ statisticalInformation[3]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[3]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[3]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.eps') }}</th>
              <td>{{ statisticalInformation[4]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[4]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[4]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.peRatio') }}</th>
              <td>{{ statisticalInformation[5]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[5]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[5]?.year_2567 || 'N/A' }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('financialInfo.statistics.pbvRatio') }}</th>
              <td>{{ statisticalInformation[6]?.year_2565 || 'N/A' }}</td>
              <td>{{ statisticalInformation[6]?.year_2566 || 'N/A' }}</td>
              <td>{{ statisticalInformation[6]?.year_2567 || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script>
import FinancialInfoTabMenu from '@/components/FinancialInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";

export default {
  name: 'Info',
  components: {
    FinancialInfoTabMenu,
  },
  data() {
    return {
      financialData: [
        { year_2564: "35,398,442,918.92", year_2565: "48,091,145", year_2566: "65,230,434", year_2567: "64,809,485" }, // สินทรัพย์รวม
        { year_2564: "19,458,443,285.79", year_2565: "28,157,820", year_2566: "44,132,569", year_2567: "43,527,073" }, // หนี้สินรวม
        { year_2564: "15,939,999,633.20", year_2565: "19,933,325", year_2566: "21,097,865", year_2567: "21,282,412" }, // ส่วนของผู้ถือหุ้น (รวม)
        { year_2564: "13,623,385,589.08", year_2565: "11,676,440", year_2566: "8,840,415", year_2567: "68,361,003" },  // รายได้จากการขาย
        { year_2564: "15,901,303,092.46	", year_2565: "16,157,151", year_2566: "15,187,019", year_2567: "11,985,297" }, // รายได้รวม
        { year_2564: "9,018,394,266.96", year_2565: "7,603,945", year_2566: "6,211,581", year_2567: "4,855,565" },    // ต้นทุนขาย
        { year_2564: "2,344,089,739.42", year_2565: "2,431,322", year_2566: "3,307,630", year_2567: "3,285,852" },    // ค่าใช้จ่ายรวม
        { year_2564: "3,193,934,937.34", year_2565: "3,774,536", year_2566: "2,718,233", year_2567: "1,051,790" },    // กำไรสุทธิ
      ],

      financialRatios: [
        { year_2564: "24.28%", year_2565: "22.83%", year_2566: "14.62%", year_2567: "5.48%" }, // อัตราผลตอบแทนผู้ถือหุ้น (ร้อยละ)	
        { year_2564: "13.14%", year_2565: "13.29%", year_2566: "7.81%", year_2567: "3.48%" },  // อัตราผลตอบแทนจากสินทรัพย์ (ร้อยละ)	
        { year_2564: "33.80%", year_2565: "34.88%", year_2566: "29.74%", year_2567: "29.0%" }, // อัตรากำไรขั้นต้น (ร้อยละ)	
        { year_2564: "20.03%", year_2565: "23.98%", year_2566: "17.93%", year_2567: "8.8%" }, // อัตรากำไรสุทธิ (ร้อยละ)		
        { year_2564: "1.22", year_2565: "1.41", year_2566: "2.08", year_2567: "2.05" }, // อัตราส่วนหนี้สินต่อส่วนของผู้ถือหุ้น D/E (เท่า)	
        { year_2564: "0.97", year_2565: "1.11", year_2566: "1.62", year_2567: "1.70" }, // อัตราส่วนหนี้สินที่มีภาระดอกเบี้ยต่อส่วนของผู้ถือหุ้น IBD/E (เท่า)	
        { year_2564: "0.44", year_2565: "0.39", year_2566: "0.30", year_2567: "0.17" }, // อัตราหมุนเวียนของสินทรัพย์รวม (เท่า)				
      ],
      statisticalInformation: [
        { year_2564: "2,452,862,453", year_2565: "2,454,122,453", year_2566: "2,454,122,453", year_2567: "2,454,122,453" }, // จำนวนหุ้นจดทะเบียน (หุ้น)	
        { year_2564: "0.50", year_2565: "0.50", year_2566: "0.50", year_2567: "0.50" }, // ราคา Par (บาท)			
        { year_2564: "27,717,346", year_2565: "29,694,880", year_2566: "20,737,330", year_2567: "8,883,920" }, // มูลค่าหลักทรัพย์ตามราคาตลาด (บาท)	
        { year_2564: "6.50", year_2565: "6.64", year_2566: "7.75", year_2567: "8.00" }, // Book Value per Share (บาท/หุ้น)	
        { year_2564: "1.30", year_2565: "1.54", year_2566: "1.11", year_2567: "0.43" }, // EPS (บาท/หุ้น)			
        { year_2564: "9.15", year_2565: "6.37", year_2566: "5.60", year_2567: "6.51" }, // P/E (เท่า)			
        { year_2564: "1.86", year_2565: "0.91", year_2566: " 1.09", year_2567: "0.17" }, // P/BV (เท่า)		
      ],
    };
  },
  methods: {
  },


  async mounted() {
    const convertToMillionBaht = (num) => {
      if (!num) return 0;
      const value = parseFloat(num.replace(/,/g, ''));
      return Math.round(value / 1000000);
    };

    const totalLabel = this.$t('financialInfo.total');
    const profitLabel = this.$t('financialInfo.profit');


    this.total_income = [
      16157151,
      15187019,
      11985297
    ];

    this.net_profit = [
      3774536,
      2718233,
      1051790
    ];


    Highcharts.chart(this.$refs.chartContainer, {
      chart: {
        type: 'column',
        backgroundColor: '#F2F2F2',
      },
      title: {
        text: '',

      },
      xAxis: {
        categories: ['2565', '2566', '2567'],
        labels: {
          style: {
            fontFamily: 'Prompt, sans-serif',
          },
        },
      },
      yAxis: {
        title: {
          text: '',
        },
        labels: {
          enabled: false,
          style: {
            fontFamily: 'Prompt, sans-serif',
          },
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0, ',', ',');
          },
        },
        lineWidth: 0,
        gridLineWidth: 0,
      },
      tooltip: {
        formatter: function () {
          return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
        },
      },

      series: [
        {
          name: totalLabel,
          data: this.total_income,
          color: '#414042',
          dataLabels: {
            enabled: true,
            style: {
              fontFamily: 'Prompt, sans-serif',
            },
            formatter: function () {
              return Highcharts.numberFormat(this.y, 0, ',', ',');
            },
          },
        },
        {
          name: profitLabel,
          data: this.net_profit,
          color: '#E87D2E',
          dataLabels: {
            enabled: true,
            style: {
              fontFamily: 'Prompt, sans-serif',
            },
            formatter: function () {
              return Highcharts.numberFormat(this.y, 0, ',', ',');
            },
          },
        },
      ],

      credits: {
        enabled: false,
      },
    });

  }

};
</script>
<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}

.table td {
  font-size: 0.85rem;
  font-weight: normal;
  padding: 8px;
  text-align: end;
}
</style>
